import { ProtectedRoute } from "@/components/ProtectedRoutes";
import { Layout } from "@/components/layouts";
import { MyPage } from "@/components/mypage";
import usePageTracking from "@/hooks/usePageTracking";
import { CouponRedeemPage } from "@/pages/Coupon/Redeem";
import { DeleteMe } from "@/pages/DeleteMe";
import { EditProfile } from "@/pages/EditProfile";
import { FAQPage } from "@/pages/Faq";
import { HomePage } from "@/pages/Home/index";
import { Login } from "@/pages/Login";
import { MyEntry } from "@/pages/MyEntry";
import { PlayerDetail } from "@/pages/PlayerDetail";
import { WithdrawalRecord } from "@/pages/Record";
import { RedeemPointsPage } from "@/pages/RedeemPoints";
import { ReferralRegisterPage } from "@/pages/Referral/Register";
import { Register } from "@/pages/Register";
import { ResultPage } from "@/pages/Result";
import { ResultSelectedPlayerPage } from "@/pages/Result/ResultPlayersPage";
import { RoundPage } from "@/pages/Rounds";
import { Prizes } from "@/pages/Rounds/Prizes";
import { SelectCaptain } from "@/pages/Rounds/SelectCaptain";
import { SelectPlayersPage } from "@/pages/Rounds/SelectPlayersPage";
import { SMSRegistration } from "@/pages/SMSRegistration";
import { SchedulePage } from "@/pages/Schedule";
import { ScheduleSelectedPlayerPage } from "@/pages/Schedule/ScheduleSelectedPlayerPage";
import { SmsStartPage } from "@/pages/SmsStartPage";
import { SMSVerificationPage } from "@/pages/SmsVerification";
import { PrivacyPolicy } from "@/pages/TermsAndPolicy/PrivacyPolicy";
import { TermsOfService } from "@/pages/TermsAndPolicy/TermsOfService";
import { TopPage } from "@/pages/Top";
import { WithdrawalHome } from "@/pages/Withdrawal";
import { EditProfileOnMypage } from "@/pages/profile/edit";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const TrackingWrapper = ({ children }: { children: React.ReactNode }) => {
  usePageTracking();
  return <>{children}</>;
};

const Root = () => {
  return (
    <BrowserRouter>
      <TrackingWrapper>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/top" element={<TopPage />} />

            <Route path="/rounds/:roundId" element={<RoundPage />} />
            <Route path="rounds/:roundId/prizes" element={<Prizes />} />
            <Route path="rounds/:roundId/select-players" element={<SelectPlayersPage />} />
            <Route path="rounds/:roundId/select-captain" element={<SelectCaptain />} />
            <Route path="/player-detail/:playerId" element={<PlayerDetail />} />

            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />

            <Route path="/faq" element={<FAQPage />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/redeem-points" element={<RedeemPointsPage />} />

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route
                path="/my-page"
                element={
                  <div className="w-5/6 md:w-1/2 lg:w-1/3 2xl:w-1/4 fixed right-0 h-full py-5 overflow-y-scroll">
                    <MyPage />
                  </div>
                }
              />
              <Route path="/edit-profile" element={<EditProfile />} />
              <Route path="/profile/edit" element={<EditProfileOnMypage />} />
              <Route path="/referral/register" element={<ReferralRegisterPage />} />

              <Route path="/my-entry" element={<MyEntry />} />
              <Route path="/scheduled/:roundEntryUnitId" element={<SchedulePage />} />
              <Route path="/scheduled/:roundEntryUnitId/entries/:entryId" element={<ScheduleSelectedPlayerPage />} />
              <Route path="/results/:roundEntryUnitId" element={<ResultPage />} />
              <Route path="/results/:roundEntryUnitId/entries/:entryId" element={<ResultSelectedPlayerPage />} />

              <Route path="/record" element={<WithdrawalRecord />} />
              <Route path="/withdrawal" element={<WithdrawalHome />} />
              <Route path="/coupon/redeem" element={<CouponRedeemPage />} />
              <Route path="/delete-me" element={<DeleteMe />} />
              <Route path="/sms-new-account" element={<SmsStartPage />} />
              <Route path="/sms-registration" element={<SMSRegistration />} />
              <Route path="/sms-verification" element={<SMSVerificationPage />} />

              {/*
              <Route element={<SMSVerificationRequiredRoute />}>
              </Route>
              */}
            </Route>
          </Route>
        </Routes>
      </TrackingWrapper>
    </BrowserRouter>
  );
};

export default Root;
